export default {
  rapid: 'Rapid',
  delayed: 'Delayed',
};
